import { useNavigate } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { IconReport } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/stores/authStore';

export function BuildReportButton() {
  const navigate = useNavigate();
  const i18n = useTranslation();
  const isAdmin = useAuthStore((state) => state.auth.user?.is_admin);
  if (!isAdmin) return null;
  return (
    <Button variant="outline" className="space-x-1" onClick={() => navigate({ to: '/cases/report' })}>
      <span>{i18n.t('build_report')}</span> <IconReport size={18} />
    </Button>
  );
}
